import { render } from "./DemandTemplateDetailsSectionRecurrence.vue?vue&type=template&id=7a634cab"
import script from "./DemandTemplateDetailsSectionRecurrence.vue?vue&type=script&lang=ts"
export * from "./DemandTemplateDetailsSectionRecurrence.vue?vue&type=script&lang=ts"
script.render = render

export default script